import { Codes, Consts, Utils } from '../../common';
import { DateFNS } from '../../common/3rd';
import { PredefinedCheckRuleOptions } from '../../types';

export const PermanentResidentPermit = (options: PredefinedCheckRuleOptions): boolean | string => {
	let { value, params, model } = options;

	const prefix = params;
	const idType = model[`${prefix}.idType`];
	// eslint-disable-next-line
	if (idType != Consts.ID_TYPE.PERMANENT_RESIDENT_PERMIT) {
		// 不是永久居住证
		return true;
	}
	if (Utils.isEmpty(value)) {
		return true;
	}

	const pass = ((): true | string => {
		if (value.length !== 15) {
			return '永久居住证号码为15位.';
		}
		// 校验国籍是否正确
		const nationality = value.substring(0, 3);
		if (!Codes.NATIONALITY.map(code => code.v).includes(nationality)) {
			return '永久居住证号码前三位不是正确的国家代码.';
		}
		// 与已经选择的国籍进行比较
		const nationalityValue = model[`${prefix}.extensionData.nationality`];
		// eslint-disable-next-line
		if (!Utils.isEmpty(nationalityValue) && nationality != nationalityValue) {
			return '永久居住证号码与已填写的国籍不符.';
		}
		const dateOfBirth = model[`${prefix}.dateOfBirth`];
		if (!Utils.isEmpty(dateOfBirth) && DateFNS.format(dateOfBirth, 'YYMMDD') !== value.substring(7, 13)) {
			return '永久居住证号码与已填写的出生日期不符.';
		}
		return true;
	})();

	return pass;
};
